import breakpoints from '@/design-tokens/breakpoints.json';
import { useMediaQuery } from './useMediaQuery';

const mobileBreakpoint = `(max-width: ${Number.parseInt(breakpoints.breakpoint.md.$value, 10) - 1}px)`;

export function useDeviceType() {
	const isPointerDevice = useMediaQuery('(pointer: fine)');
	const isTouchDevice = useMediaQuery('(pointer: coarse)');
	const isNarrowScreen = useMediaQuery(mobileBreakpoint);

	return { isPointerDevice, isTouchDevice, isNarrowScreen };
}
